class AdminSettingsPoliciesCalendarController {
  constructor(
    UserService,
    $state,
    UsersModel,
    PoliciesModel,
    PoliciesStoreService,
    FlashService,
  ) {
    this.UserService = UserService;
    this.$state = $state;
    this.UsersModel = UsersModel;
    this.PoliciesModel = PoliciesModel;
    this.PoliciesStoreService = PoliciesStoreService;
    this.FlashService = FlashService;
    this.loading = true;
    this.busy = true;
    this.policies = {
      calendar: { id: 0, policymeta: {} },
    };

    this.processPolicy = this.processPolicy.bind(this);

    const calendarPolicy = PoliciesStoreService.getPolicy("calendar");
    if (calendarPolicy) {
      const policyMeta = { ...calendarPolicy.policymeta };
      policyMeta.id = calendarPolicy.id;
      this.policies.calendar = {
        id: calendarPolicy.id,
        policymeta: policyMeta,
      };
    }
    this.loading = false;
    this.busy = false;
  }

  processPolicy(isValid) {
    if (isValid) {
      this.busy = true;
      const payload = this.policies.calendar.policymeta;
      this.PoliciesModel.update(payload).then((response) => {
        this.busy = false;
        this.FlashService.setMessage({
          type: "success",
          message: response.message,
        });
        this.PoliciesStoreService.writePolicy("calendar", payload);
      });
    } else {
      this.FlashService.setMessage({
        type: "error",
        message: "All fields are required.",
      });
    }
  }
}
AdminSettingsPoliciesCalendarController.$inject = [
  "UserService",
  "$state",
  "UsersModel",
  "PoliciesModel",
  "PoliciesStoreService",
  "FlashService",
];
export default AdminSettingsPoliciesCalendarController;
